import {
  LimitFragment,
  LimitMembershipAwardCountFragment,
  LimitMembershipAwardCountInTimeFragment,
} from '@ocx/graphql';

export const isMembershipAwardCountLimit = (
  limit: LimitFragment,
): limit is LimitMembershipAwardCountFragment | LimitMembershipAwardCountInTimeFragment =>
  ['LimitMembershipAwardCount', 'LimitMembershipAwardCountInTime'].includes(limit.__typename);
